/* @source catpaw @line_count 87 @branch feature/ywh-ones-89612040*/
<template>
  <BikeDialog v-model="config.visible" v-bind="config" :showDefaultFooter="false" @close="onClose">
    <mtd-loading :loading="isLoading">
      <p v-for="(item, index) in detailList" :key="index">
        {{ item }}
      </p>
    </mtd-loading>
    <template #footer>
      <mtd-button @click="onClose">关闭</mtd-button>
    </template>
  </BikeDialog>
</template>

<script>
export default {
  name: 'AppealDetailDialog',
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Number,
      required: true,
    },
    statusName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      detailList: [],
      isLoading: false,
    }
  },
  mounted() {
    this.getAppealDetail()
  },
  methods: {
    getAppealDetail() {
      this.isLoading = true
      const params = {
        id: this.id,
        businessType: '1004',
      }
      this.fetch
        .get('reconcileBill_appealDetail', { params })
        .then(res => {
          const data = res.data || []
          if (data.length) {
            const { remark } = data.pop() || {}
            this.detailList = remark || []
            if (this.detailList.length) {
              this.detailList.splice(2, 0, `申诉状态:${this.statusName || '-'}`)
            }
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>
